import React from 'react';
import { CheckCircleFilled } from '@ant-design/icons';
import Wrapper, { Menu } from './style';
import color from '../../configs/color';

const Index = (props) => {
  const {
    setSelectedRadio,
    selectedRadio,
    radioOptions,
    radioPadding,
    radioLayout = 'horizontal',
    width,
    onChange,
    fullWidth,
    block,
    columnNum,
  } = props;

  return (
    <Wrapper
      className="container_radio_grup_wrapper"
      layout={radioLayout}
      width={width}
      columnNum={columnNum}
    >
      {radioOptions.map((item) => {
        const subOptions = item?.subOptions;
        const isIncludes = subOptions?.find((sub) => {
          return sub?.value === selectedRadio;
        });
        return (
          <Menu
            block={block}
            fullWidth={fullWidth}
            radioPadding={radioPadding}
            key={item?.value}
            onClick={() => {
              setSelectedRadio(item.value);
              if (onChange) {
                onChange(item.value);
              }
            }}
            className={`font-paragraph_medium ${
              selectedRadio === item?.value ? 'selected' : ''
            } ${isIncludes ? 'selected' : ''}`}
          >
            {selectedRadio === item?.value || isIncludes ? (
              <CheckCircleFilled
                style={{ color: color.orange1 }}
                className="selected_radio"
              />
            ) : (
              <div className="custom_radio" />
            )}
            {item.icon && item.icon}
            <div className="component_radio_group_text">
              <div className="component_radio_group_text_label">
                {item?.label}
              </div>
              {item?.description && (
                <div className="font-caption black3 component_description">
                  {item?.description}
                </div>
              )}
            </div>
          </Menu>
        );
      })}
    </Wrapper>
  );
};

export default Index;
